// extracted by mini-css-extract-plugin
export default {"file-error":"FeedCardFileError_file-error__cE2Gi","file-error__message":"FeedCardFileError_file-error__message__afjEw"};